import { Badge, Icon } from '@chakra-ui/react';

// Admin Imports
// import DashboardsDefault from 'views/admin/dashboards/default';
// import DashboardsRTLDefault from 'views/admin/dashboards/rtl';
// import DashboardsCarInterface from 'views/admin/dashboards/carInterface';
// import DashboardsSmartHome from 'views/admin/dashboards/smartHome';

// // NFT Imports
// import NFTMarketplace from 'views/admin/nfts/marketplace';
// import NFTPage from 'views/admin/nfts/page';
// import NFTCollection from 'views/admin/nfts/collection';
// import NFTProfile from 'views/admin/nfts/profile';

// // Main Imports
// import AccountBilling from 'views/admin/main/account/billing';
// import AccountApplications from 'views/admin/main/account/application';
// import AccountInvoice from 'views/admin/main/account/invoice';
// import AccountSettings from 'views/admin/main/account/settings';
// import AccountAllCourses from 'views/admin/main/account/courses';
// import AccountCoursePage from 'views/admin/main/account/coursePage';

// import UserNew from 'views/admin/main/users/newUser';
// import UsersOverview from 'views/admin/main/users/overview';
// import UsersReports from 'views/admin/main/users/reports';

// import ProfileSettings from 'views/admin/main/profile/settings';
// import ProfileOverview from 'views/admin/main/profile/overview';
// import ProfileNewsfeed from 'views/admin/main/profile/newsfeed';

// import ApplicationsKanban from 'views/admin/main/applications/kanban';
// import ApplicationsDataTables from 'views/admin/main/applications/dataTables';
// import ApplicationsCalendar from 'views/admin/main/applications/calendar';

// import EcommerceNewProduct from 'views/admin/main/ecommerce/newProduct';
// import EcommerceProductOverview from 'views/admin/main/ecommerce/overviewProduct';
// import EcommerceProductSettings from 'views/admin/main/ecommerce/settingsProduct';
// import EcommerceProductPage from 'views/admin/main/ecommerce/pageProduct';
// import EcommerceOrderList from 'views/admin/main/ecommerce/orderList';
// import EcommerceOrderDetails from 'views/admin/main/ecommerce/orderDetails';
// import EcommerceReferrals from 'views/admin/main/ecommerce/referrals';

// // Others
// import OthersNotifications from 'views/admin/main/others/notifications';
// import OthersPricing from 'views/admin/main/others/pricing';
// import OthersError from 'views/admin/main/others/404';
// import Messages from 'views/admin/main/others/messages';

// // Auth Imports
// import ForgotPasswordCentered from 'views/auth/forgotPassword/ForgotPasswordCentered.jsx';
// import ForgotPasswordDefault from 'views/auth/forgotPassword/ForgotPasswordDefault.jsx';
// import LockCentered from 'views/auth/lock/LockCentered.jsx';
// import LockDefault from 'views/auth/lock/LockDefault.jsx';
// import SignInCentered from 'views/auth/signIn/SignInCentered.jsx';
// import SignInDefault from 'views/auth/signIn/SignInDefault.jsx';
// import SignUpCentered from 'views/auth/signUp/SignUpCentered.jsx';
// import SignUpDefault from 'views/auth/signUp/SignUpDefault.jsx';
// import VerificationCentered from 'views/auth/verification/VerificationCentered.jsx';
// import VerificationDefault from 'views/auth/verification/VerificationDefault.jsx';

import InvoiceList from 'pages/Cockpit/AccountingInternal';
import CreateInvoice from 'pages/Cockpit/AccountingInternal/CreateInvoice';
import CreateSetOff from 'pages/Cockpit/AccountingInternal/CreateSetOff';
import InvoiceDetail from 'pages/Cockpit/AccountingInternal/InvoiceDetail';
import CashflowModel from 'pages/Cockpit/CashflowModel';
import QuickCashflowModel from 'pages/Cockpit/QuickCashflowModel';
import QuickCashflowModelClassic from 'pages/Cockpit/QuickCashflowModelClassic';
import FprSimulator from 'pages/Cockpit/QuickCashflowModel/FprSimulator';
import FinancialSnapshotData from 'pages/Cockpit/QuickCashflowModel/FinancialSnapshotData';
import TermSheetList from 'pages/Cockpit/TermSheet/TermSheetList';
import TermSheetEditor from 'pages/Cockpit/TermSheet/TermSheetEditor';
import QuickCashflowAiConfigAdmin from 'pages/Cockpit/Admin/QuickCashflowAiConfig';
import MailIntakePromptConfigAdmin from 'pages/Cockpit/Admin/MailIntakePromptConfig';
import GoogleAlertRelevancePromptConfigAdmin from 'pages/Cockpit/Admin/GoogleAlertRelevancePromptConfig';
import TearsheetScorecardConfigAdmin from 'pages/Cockpit/Admin/TearsheetScorecardConfig';
import ToolingHome from 'pages/Cockpit/Tooling';
import CohortMarkovFill from 'pages/Cockpit/Tooling/CohortMarkovFill';
import AiPrompt from 'pages/Cockpit/Tooling/AiPrompt';
import BankTransactions from 'pages/Cockpit/Customer/Banking/BankTransactions';
import Accounting from 'pages/Cockpit/Customer/Accounting/Accounting';
import ConnectorList from 'pages/Cockpit/Customer/Connectors/ConnectorList';
import CustomerConfiguration from 'pages/Cockpit/Customer/CustomerConfiguration';
import CustomerOverview from 'pages/Cockpit/Customer/CustomersOverview';
import CustomerPipeline from 'pages/Cockpit/Pipeline';
import CustomerSettings from 'pages/Cockpit/Customer/Performance/CustomerSettings';
import Deal from 'pages/Cockpit/Customer/Performance/Deal';
import Marketing from 'pages/Cockpit/Customer/Performance/Marketing';
import MarketingPerformance from 'pages/Cockpit/Customer/Performance/MarketingPerformance';
import Sales from 'pages/Cockpit/Customer/Performance/Sales';
import Tearsheet from 'pages/Cockpit/Customer/Performance/Tearsheet/Tearsheet';
import TearsheetNew from 'pages/Cockpit/Customer/Performance/Tearsheet/TearsheetNew';
import TearsheetOverview from 'pages/Cockpit/Customer/Performance/Tearsheet/TearsheetOverview';
import Monitoring from 'pages/Cockpit/Customer/Performance/Monitoring';
import MonitoringConfig from 'pages/Cockpit/Customer/Performance/MonitoringConfig';
import Underwriting from 'pages/Cockpit/Customer/Performance/Underwriting/Underwriting';
import UnderwritingNew from 'pages/Cockpit/Customer/Performance/Underwriting/UnderwritingNew';
import UnderwritingOverview from 'pages/Cockpit/Customer/Performance/Underwriting/UnderwritingOverview';
import OperationsDeal from 'pages/Cockpit/Operations/Deal';
import DealsOverview from 'pages/Cockpit/Operations/DealsOverview';
import FacilityFee from 'pages/Cockpit/Operations/FacilityFee';
import Installment from 'pages/Cockpit/Operations/Installment';
import OperationsCustomerOverview from 'pages/Cockpit/Operations/OperationsCustomerOverview';
import OperationsOverview from 'pages/Cockpit/Operations/OperationsOverview';
import SourcesAndUses from 'pages/Cockpit/Operations/SourcesAndUses';
import Repayment from 'pages/Cockpit/Operations/Repayment';
import Test from 'pages/Test';
import Help from 'pages/Help/Help';
import Alerts from 'pages/Cockpit/Alerts';
import DataMonitoring from 'pages/Cockpit/Monitoring';
import AlertsBadge from 'components/AlertsBadge';
import { BsBellFill } from 'react-icons/bs';
import { FaChartLine } from 'react-icons/fa';
import { FaSackDollar } from 'react-icons/fa6';
import { LiaUserFriendsSolid } from 'react-icons/lia';
import { MdOutlineFactCheck, MdOutlineBuild, MdOutlineMonitorHeart, MdOutlineTimeline, MdOutlineReceiptLong, MdOutlineAccountBalance } from 'react-icons/md';
import { QuestionIcon } from '@chakra-ui/icons';

export const createCockpitRoutes = ({ location }) => {
  const customerId = location.pathname.split('/')[2];

  const isActiveRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const createCustomerRoutes = () => {
    return [
      {
        name: 'Performance',
        path: `/customers/:customerId/performance`,
        link: '',
        hide: !isActiveRoute(`/customers/${customerId}`),
        collapse: true,
        isOpen: true,
        items: [
          {
            name: 'Marketing',
            path: `/customers/:customerId/performance/marketing`,
            link: `/customers/${customerId}/performance/marketing`,
            component: <Marketing />,
          },
          {
            name: 'Marketing performance',
            path: `/customers/:customerId/performance/marketing-performance`,
            link: `/customers/${customerId}/performance/marketing-performance`,
            component: <MarketingPerformance />,
          },
          {
            name: 'Sales',
            path: `/customers/:customerId/performance/sales`,
            link: `/customers/${customerId}/performance/sales`,
            hasAnchorLinks: true,
            component: <Sales />,
            items: !isActiveRoute('/performance/sales')
              ? null
              : [
                  {
                    name: 'Highlights',
                    link: 'highlights',
                  },
                  {
                    name: 'Revenue/Cashflow',
                    link: 'revenue',
                  },
                  {
                    name: 'ROAS',
                    link: 'roas',
                  },                  {
                    name: 'ARPU',
                    link: 'arpu',
                  },
                  {
                    name: 'LTV',
                    link: 'ltv',
                  },
                  {
                    name: 'Cohort Trends',
                    link: 'cohortTrends',
                  },
                  {
                    name: 'Users',
                    link: 'users',
                  },
                ],
          },
          {
            name: 'Deal',
            path: `/customers/:customerId/performance/deal`,
            link: `/customers/${customerId}/performance/deal`,
            component: <Deal />,
            hasAnchorLinks: true,
            hide: true,
            items: !isActiveRoute('/performance/deal')
              ? null
              : [
                  {
                    name: 'Highlights',
                    link: 'highlights',
                  },
                  {
                    name: 'Exposure',
                    link: 'exposure',
                  },
                  {
                    name: 'Funding',
                    link: 'funding',
                  },
                  {
                    name: 'Repayment',
                    link: 'repayment',
                  },
                ],
          },
          {
            name: 'Tearsheet',
            path: `/customers/:customerId/performance/tearsheet`,
            link: `/customers/${customerId}/performance/tearsheet`,
            component: <TearsheetOverview />,
          },
          {
            name: 'Tearsheet',
            path: `/customers/:customerId/performance/tearsheet/:tearsheetId`,
            link: `/customers/${customerId}/performance/tearsheet`,
            component: <Tearsheet />,
            hide: true,
          },
          {
            name: 'Tearsheet New',
            path: `/customers/:customerId/performance/tearsheet_new`,
            link: `/customers/${customerId}/performance/tearsheet_new`,
            component: <TearsheetNew />,
          },
          {
            name: 'Tearsheet New',
            path: `/customers/:customerId/performance/tearsheet_new/:tearsheetId`,
            link: `/customers/${customerId}/performance/tearsheet_new`,
            component: <TearsheetNew />,
            hide: true,
          },
          {
            name: 'Monitoring',
            path: `/customers/:customerId/performance/monitoring`,
            link: `/customers/${customerId}/performance/monitoring`,
            component: <Monitoring />,
          },
          {
            name: 'Monitoring',
            path: `/customers/:customerId/performance/monitoring/:monitoringId`,
            link: `/customers/${customerId}/performance/monitoring`,
            component: <Monitoring />,
            hide: true,
          },
          {
            name: 'Monitoring Config',
            path: `/customers/:customerId/performance/monitoring-config`,
            link: `/customers/${customerId}/performance/monitoring-config`,
            component: <MonitoringConfig />,
          },
          {
            name: 'Underwriting',
            path: `/customers/:customerId/performance/underwriting`,
            link: `/customers/${customerId}/performance/underwriting`,
            component: <UnderwritingOverview />,
          },
          {
            name: 'Underwriting',
            path: `/customers/:customerId/performance/underwriting/new`,
            link: `/customers/${customerId}/performance/underwriting`,
            component: <Underwriting />,
            hide: true,
          },
          {
            name: 'Underwriting',
            path: `/customers/:customerId/performance/underwriting/:underwritingId`,
            link: `/customers/${customerId}/performance/underwriting`,
            component: <Underwriting />,
            hide: true,
          },
          {
            name: 'Underwriting New',
            path: `/customers/:customerId/performance/underwriting_new/new`,
            link: `/customers/${customerId}/performance/underwriting_new`,
            component: <UnderwritingNew />,
            hide: true,
          },
          {
            name: 'Underwriting New',
            path: `/customers/:customerId/performance/underwriting_new/:underwritingId`,
            link: `/customers/${customerId}/performance/underwriting_new`,
            component: <UnderwritingNew />,
            hide: true,
          },
        ],
      },
      {
        name: 'First Underwriting',
        path: `/customers/:customerId/first-underwriting`,
        link: '',
        hide: !isActiveRoute(`/customers/${customerId}`),
        collapse: true,
        isOpen: true,
        items: [
          {
            name: 'Create',
            path: `/customers/:customerId/first-underwriting/create`,
            link: `/customers/${customerId}/first-underwriting/create`,
            component: <QuickCashflowModel />,
          },
          {
            name: 'Cashflow',
            path: `/customers/:customerId/first-underwriting/create-classic`,
            link: `/customers/${customerId}/first-underwriting/create-classic`,
            component: <QuickCashflowModelClassic />,
          },
          {
            name: 'FPR',
            path: `/customers/:customerId/first-underwriting/fpr`,
            link: `/customers/${customerId}/first-underwriting/fpr`,
            component: <FprSimulator />,
          },
          {
            name: 'Data Extractor',
            path: `/customers/:customerId/first-underwriting/data`,
            link: `/customers/${customerId}/first-underwriting/data`,
            component: <FinancialSnapshotData />,
          },
        ],
      },
      {
        name: 'Term Sheet',
        path: `/customers/:customerId/term-sheets`,
        link: `/customers/${customerId}/term-sheets`,
        component: <TermSheetList />,
      },
      {
        name: 'Term Sheet Editor',
        path: `/customers/:customerId/term-sheets/:termSheetId`,
        link: `/customers/${customerId}/term-sheets`,
        component: <TermSheetEditor />,
        hide: true,
      },
      {
        name: 'Settings',
        path: `/customers/:customerId/settings`,
        link: `/customers/${customerId}/settings`,
        component: <CustomerSettings />,
      },
      {
        name: 'Users',
        path: `/customers/:customerId/configuration`,
        link: `/customers/${customerId}/configuration`,
        hide: !isActiveRoute(`/customers/${customerId}`),
        component: <CustomerConfiguration />,
      },
      {
        name: 'Connectors',
        path: `/customers/:customerId/connectors`,
        link: `/customers/${customerId}/connectors`,
        hide: !isActiveRoute(`/customers/${customerId}`),
        component: <ConnectorList />,
      },
      {
        name: 'Bank Transactions',
        path: `/customers/:customerId/bank-transactions`,
        link: `/customers/${customerId}/bank-transactions`,
        hide: !isActiveRoute(`/customers/${customerId}`),
        component: <BankTransactions />,
      },
      {
        name: 'Accounting',
        path: `/customers/:customerId/accounting`,
        link: `/customers/${customerId}/accounting`,
        hide: !isActiveRoute(`/customers/${customerId}`),
        component: <Accounting />,
      },
    ];
  };

  const createOperationsRoutes = () => {
    return [
      {
        name: 'Installments',
        path: '/operations/:customerId/installment',
        link: `/operations/${customerId}/installment`,
        component: <OperationsCustomerOverview />,
      },
      {
        name: 'Installments',
        path: '/operations/:customerId/installment/new',
        hide: true,
        component: <Installment />,
      },
      {
        name: 'Installments',
        path: '/operations/:customerId/installment/:installmentId',
        hide: true,
        component: <Installment />,
      },
      {
        name: 'Installments',
        path: '/operations/:customerId/repayment',
        hide: true,
        component: <Repayment />,
      },
      {
        name: 'Deals',
        path: '/operations/:customerId/deal',
        link: `/operations/${customerId}/deal`,
        component: <DealsOverview />,
      },
      {
        name: 'Deals',
        path: '/operations/:customerId/deal/new',
        hide: true,
        component: <OperationsDeal />,
      },
      {
        name: 'Deals',
        path: '/operations/:customerId/deal/:dealId',
        hide: true,
        component: <OperationsDeal />,
      },
      {
        name: 'Facility Fees',
        path: '/operations/:customerId/facility-fee',
        link: `/operations/${customerId}/facility-fee`,
        component: <FacilityFee />,
      },
    ];
  };

  const createPerformanceRoutes = () => {
    const customerId = sessionStorage.getItem('playgroundCustomerId');
    const addCustomerId = (path) => {
      if (!customerId) {
        return path;
      }
      return path + '?customerId=' + customerId;
    };
    return [
      {
        name: 'Marketing',
        path: '/performance/marketing',
        link: addCustomerId('/performance/marketing'),
        component: <Marketing isPlayground={true} />,
      },
      {
        name: 'Marketing performance',
        path: '/performance/marketing-performance',
        link: addCustomerId('/performance/marketing-performance'),
        component: <MarketingPerformance isPlayground={true} />,
      },
      {
        name: 'Sales',
        path: '/performance/sales',
        link: addCustomerId('/performance/sales'),
        component: <Sales isPlayground={true} />,
      },
    ];
  };

  const routes = [
    // --- Dashboards ---
    {
      name: 'Performance',
      path: '/performance',
      link: '',
      icon: (
        <Icon as={FaChartLine} width="20px" height="20px" color="inherit" />
      ),
      items: createPerformanceRoutes(),
    },
    {
      name: 'Customers',
      path: '/customers',
      link: '/customers',
      icon: (
        <Icon
          as={LiaUserFriendsSolid}
          width="24px"
          height="24px"
          color="inherit"
          mx={'-2px'}
        />
      ),
      component: <CustomerOverview />,
      items: isActiveRoute(`/customers/${customerId}`)
        ? createCustomerRoutes()
        : null,
    },
    {
      name: 'Pipeline',
      path: '/pipeline',
      link: '/pipeline',
      icon: (
        <Icon
          as={MdOutlineTimeline}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      component: <CustomerPipeline />,
    },
    {
      name: 'Cash Flow Model',
      path: '/cashflow',
      link: '',
      collapse: true,
      icon: (
        <Icon as={FaSackDollar} width="20px" height="20px" color="inherit" />
      ),
      items: [
        {
          name: 'Cash Flow Model',
          path: '/cashflow-model',
          link: '/cashflow-model',
          collapse: false,
          component: <CashflowModel />,
        },
      ],
    },
    {
      name: 'Tooling',
      path: '',
      link: '',
      collapse: true,
      icon: (
        <Icon
          as={MdOutlineBuild}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      items: [
        {
          name: 'Overview',
          path: '/tooling',
          link: '/tooling',
          collapse: false,
          component: <ToolingHome />,
        },
        {
          name: 'Cohort Markov Fill',
          path: '/tooling/cohort-markov-fill',
          link: '/tooling/cohort-markov-fill',
          collapse: false,
          component: <CohortMarkovFill />,
        },
        {
          name: 'AI Prompt',
          path: '/tooling/ai-prompt',
          link: '/tooling/ai-prompt',
          collapse: false,
          component: <AiPrompt />,
        },
      ],
    },
    {
      name: 'Configurations',
      path: '',
      link: '',
      collapse: true,
      icon: (
        <Icon
          as={MdOutlineFactCheck}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      items: [
        {
          name: 'Tearsheet Scorecard',
          path: '/admin/tearsheet-scorecard-config',
          link: '/admin/tearsheet-scorecard-config',
          collapse: false,
          component: <TearsheetScorecardConfigAdmin />,
        },
        {
          name: 'Quick Cash Flow AI',
          path: '/admin/quick-cashflow-ai-config',
          link: '/admin/quick-cashflow-ai-config',
          collapse: false,
          component: <QuickCashflowAiConfigAdmin />,
        },
        {
          name: 'Mail Intake',
          path: '/admin/mail-intake-prompt-config',
          link: '/admin/mail-intake-prompt-config',
          collapse: false,
          component: <MailIntakePromptConfigAdmin />,
        },
        {
          name: 'Google Alerts',
          path: '/admin/google-alert-relevance-prompt-config',
          link: '/admin/google-alert-relevance-prompt-config',
          collapse: false,
          component: <GoogleAlertRelevancePromptConfigAdmin />,
        },
      ],
    },
    {
      name: 'Asset Tape',
      path: '/operations',
      link: '/operations',
      collapse: false,
      icon: (
        <Icon as={FaSackDollar} width="20px" height="20px" color="inherit" />
      ),
      component: <OperationsOverview />,
      items: isActiveRoute(`/operations/${customerId}`)
        ? createOperationsRoutes()
        : null,
    },
    {
      name: 'Sources & Uses',
      path: '/sources-and-uses',
      link: '/sources-and-uses',
      collapse: false,
      icon: (
        <Icon as={MdOutlineAccountBalance} width="20px" height="20px" color="inherit" />
      ),
      component: <SourcesAndUses />,
    },
    {
      name: 'Accounting Internal',
      path: '/accounting-internal',
      link: '/accounting-internal',
      collapse: false,
      icon: (
        <Icon as={MdOutlineReceiptLong} width="20px" height="20px" color="inherit" />
      ),
      component: <InvoiceList />,
    },
    {
      name: 'Create Invoice',
      path: '/accounting-internal/new',
      hide: true,
      component: <CreateInvoice />,
    },
    {
      name: 'Create Set-Off',
      path: '/accounting-internal/set-off/new',
      hide: true,
      component: <CreateSetOff />,
    },
    {
      name: 'Invoice Detail',
      path: '/accounting-internal/:invoiceId',
      hide: true,
      component: <InvoiceDetail />,
    },
    {
      name: 'Alerts',
      path: '/alerts',
      link: '/alerts',
      collapse: false,
      icon: (
        <Icon as={BsBellFill} width="20px" height="20px" color="inherit" />
      ),
      badge: <AlertsBadge />,
      component: <Alerts />,
    },
    {
      name: 'Data Monitoring',
      path: '/monitoring',
      link: '/monitoring',
      collapse: false,
      icon: (
        <Icon as={MdOutlineMonitorHeart} width="20px" height="20px" color="inherit" />
      ),
      component: <DataMonitoring />,
    },
    {
      name: 'Help',
      path: '/help',
      link: '/help',
      icon: <QuestionIcon width="20px" height="20px" color="inherit" />,
      component: <Help />,
      hide: true,
    },
    {
      name: 'Test',
      path: '/test',
      component: <Test />,
      hide: true,
    },
  ];

  return routes;
};
